import * as React from 'react';

import classnames from 'classnames';

import {Button} from '../button/button';
import {RemoveButton} from '../button/remove-button/remove-button';
import {Dialog} from '../dialog/dialog';
import {ErrorMessage} from '../form/error-message';
// @ts-expect-error - imported from .js/.jsx file
import {DownloadIcon} from '../icon/svg/download-icon';
import {Link} from '../link/link';
import {LinkedEntity} from '../linked-entity/linked-entity';
import {RelativeTimestamp} from '../timestamp/relative-timestamp';

import {FileIcon} from './file-icon';

import styles from './file.module.css';

type Props = {
    id: string;
    filename: string;
    filetype: string;
    href: string;
    creatorName?: string;
    createdTime?: number;
    isProcessing?: boolean;
    hasTimedOut?: boolean;
    onConfirmDelete?: () => any;
    onReprocessFile?: () => any;
    withDownloadIcon?: boolean;
    withNoBorder?: boolean;
};

export function File(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const deleteRef = React.useRef(null);

    const styleName = classnames(styles['file'], {
        [styles['file--no-border']]: props.withNoBorder,
        [styles['file--removable']]: props.onConfirmDelete,
    });

    return (
        <li id={`file-${props.id}`} className={styleName}>
            <FileIcon href={props.href} filename={props.filename} filetype={props.filetype} />
            <div className={styles['file-contents']}>
                <div className={styles['file-row']}>
                    {props.withDownloadIcon ? (
                        <p title={props.filename} className={styles['file-name']}>
                            {props.filename}
                        </p>
                    ) : (
                        // @ts-expect-error
                        <Link variant='secondary' href={props.href} title={props.filename}>
                            {props.filename}
                        </Link>
                    )}
                </div>
                {props.creatorName || props.createdTime ? (
                    <div className={styles['file-row']}>
                        {props.creatorName ? (
                            <LinkedEntity type='users' name={props.creatorName} />
                        ) : (
                            <div />
                        )}
                        {props.createdTime ? (
                            <div className={styles['timestamp']}>
                                <RelativeTimestamp datetime={props.createdTime} />
                            </div>
                        ) : undefined}
                    </div>
                ) : undefined}
            </div>
            {props.isProcessing || props.hasTimedOut ? (
                <div className={styles['overlay']} />
            ) : undefined}
            {props.isProcessing ? (
                <div className={styles['overlay-text']}>
                    <span className={styles['processing']}>Processing…</span>
                </div>
            ) : undefined}
            {props.hasTimedOut ? (
                <div className={styles['overlay-text']}>
                    <ErrorMessage>Failed</ErrorMessage>
                    {/* @ts-expect-error */}
                    <Button variant='text-primary' size='big' onClick={props.onReprocessFile}>
                        Retry?
                    </Button>
                </div>
            ) : undefined}
            {props.withDownloadIcon ? (
                <div className={styles['download-button']}>
                    <Link variant='secondary' href={props.href}>
                        <DownloadIcon size={17} />
                    </Link>
                </div>
            ) : undefined}
            {props.onConfirmDelete ? (
                <div className={styles['remove-button']}>
                    <RemoveButton
                        size={12}
                        getButtonRef={deleteRef}
                        onClick={() => setIsConfirmingDelete(true)}
                    />
                </div>
            ) : undefined}
            {isConfirmingDelete ? (
                <Dialog
                    anchor={deleteRef.current}
                    location='left'
                    question='Are you sure you want to delete this file?'
                    onPrimary={props.onConfirmDelete}
                    onSecondary={() => setIsConfirmingDelete(false)}
                />
            ) : undefined}
        </li>
    );
}
